import { useEffect } from 'react';

/**
 * Asks the browser to confirm before a reload or a closed tab throws away an
 * edited form. In-app navigation is not covered: the tests mount the panel
 * under a plain `MemoryRouter`, where a router blocker cannot exist.
 */
export function useUnsavedChangesPrompt(dirty: boolean): void {
  useEffect(() => {
    if (!dirty) return undefined;
    const onBeforeUnload = (event: BeforeUnloadEvent): void => {
      event.preventDefault();
      // Chromium still wants a value assigned before it will ask.
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, [dirty]);
}
